import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useStore } from 'zustand';

import {
  ActionButton,
  breakpoints,
  FormControl,
  Input,
  Toaster,
} from '@notino/react-styleguide';

import messages from '@components/Universals/WishlistModifier/messages';
import { useWishlistLists } from '@components/Universals/WishlistModifier/useWishlistLists';
import { LIST_NAME_MAX_CHARS } from '@containers/WishlistLists/constants';
import { useListDataCache } from '@containers/WishlistLists/hooks/useListsData';
import { styled } from '@linaria/react';

import { useCloseListMenuDrawer, useListMenuContext } from '../context';
import menuMessages, { listNotificationMessages } from '../messages';

const Wrapper = styled.div`
  padding: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const Footer = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
  padding-bottom: 2rem;
  @media (min-width: ${breakpoints.md}) {
    padding-bottom: 0;
  }
`;

const SaveButton = styled(ActionButton)`
  width: 100%;
  margin-top: 1.25rem;
`;

export const Rename = () => {
  const { formatMessage } = useIntl();
  const { store } = useListMenuContext();
  const onClose = useCloseListMenuDrawer();
  const { list: _list } = useStore(store);
  const list = _list!;

  const { renameList } = useWishlistLists();
  const { renameListCache } = useListDataCache();

  const [name, setName] = React.useState(list.name ?? '');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const onSave = async () => {
    setError(false);
    setLoading(true);
    try {
      await renameList({ name, listId: list.id });
      renameListCache(list.id, name);
      onClose();
      Toaster.info({
        icon: 'IconRegularCheckmark',
        content: <FormattedMessage {...listNotificationMessages.listRenamed} />,
      });
    } catch (e) {
      setError(true);
    }
    setLoading(false);
  };

  return (
    <Wrapper>
      <FormControl label={formatMessage(menuMessages.renameListLabel)}>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus={true}
        />
      </FormControl>

      <Footer>
        <SaveButton
          onClick={onSave}
          isLoading={loading}
          error={error}
          disabled={
            !name || name === list.name || name.length > LIST_NAME_MAX_CHARS
          }
        >
          <FormattedMessage {...messages.saveButton} />
        </SaveButton>
      </Footer>
    </Wrapper>
  );
};
